import $ from 'jquery';
import MicroModal from 'micromodal';
import { replaceUrlParam } from '../utilities.js';
import { TagManager } from '@dealersites/tag-manager/tag-manager';
import { InventorySearchEvents } from '@dealersites/inventory/events';

$('#loader').hide();

// Quick queries
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.get('tab')) {
  const id = urlParams.get('tab');
  $(`.${id}`)
    .parents('.tab-group')
    .find('.nav-link')
    .each(function () {
      $(this).removeClass('active');
    });
  $(`.${id}`).addClass('active').addClass;
}
if (urlParams.get('title') || urlParams.get('dsp_title')) {
  runDots($('#dsp-title'));
  runResets();
}

if (urlParams.get('dsp_price_min') || urlParams.get('dsp_price_max')) {
  const min = urlParams.get('dsp_price_min');
  const max = urlParams.get('dsp_price_max');
  runResets();
  if (urlParams.get('price_input')) {
    runDots($('.js-price-input'));
    $('#price-max').val(max);
    $('#price-min').val(min);
  }
  if (urlParams.get('price_btn')) {
    $('.js-price-btn').each(function () {
      if ($(this).val() == max) {
        $(this).attr('checked', true);
        runDots($('.js-price-btn'));
      }
    });
  }
}

// Filters Collapse Panes
// clicking on pane will not collapse the pane
$('.vlp-filter-collapse')
  .find('.collapse-pane')
  .on('click', function (e) {
    e.stopPropagation();
  });

// Filter/Search Activity Dots (Dropdowns)
$(
  '.js-filter .filter-container input:not([type=checkbox]), .js-filter .filter-container select',
).each(function () {
  const value = $(this).val();
  if (value) {
    runDots($(this));
    runResets();
  }
});

$('.vlp-results').on('change', '.js-filter input, .js-filter select', function () {
  runDots($(this));
  runResets();
});

$('.js-price-btn').on('change', function () {
  if ($(this).prop('checked')) {
    const max = $(this).val();
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, 'dsp_price_min', 0);
    newUrl = replaceUrlParam(newUrl, 'dsp_price_max', max);
    newUrl = replaceUrlParam(newUrl, 'price_btn', true);
    window.location.assign(newUrl);
    // tag
    const status = $('.search-results').attr('data-sale-status');
    const config = {
      onclick: {
        onclick: status + ':si:vls:filter:price',
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
      },
    };
    TagManager.trackEvent('global-onclick', config);
  }
});

$('.js-price-input').on('change', function () {
  const value = $(this).val();
  if (parseInt(value)) {
    const param = $(this).data('param');
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, param, value);
    newUrl = replaceUrlParam(newUrl, 'price_input', true);
    window.location.assign(newUrl);
  }
  // tag
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:filter:price',
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

MicroModal.init();

$('#js-open-filters').on('click', function () {
  $('.js-filter').removeClass('hidden');
  $('.js-filter-short').addClass('hidden');
  $('.js-filter:not(.js-make-filter)').each(function () {
    $(this).parents('.collapse-nav').removeClass('active');
    $(this).find('.collapse-pane').removeClass('show');
  });

  MicroModal.show('modal-filters', {
    onShow: onShow,
    onClose: onClose,
  });
});

$('#js-open-model-filters').on('click', function () {
  $('.js-filter').addClass('hidden');
  $('.js-filter-short').addClass('hidden');
  $('.js-model-filter').removeClass('hidden');
  $('.js-show-all').removeClass('hidden');
  $('.js-model-filter').parents('.collapse-nav').trigger('click');
  MicroModal.show('modal-filters', {
    onShow: onShow,
    onClose: onClose,
  });
});

$('#js-open-price-filters').on('click', function () {
  $('.js-filter').addClass('hidden');
  $('.js-filter-short').addClass('hidden');
  $('.js-price-filter').removeClass('hidden');
  $('.js-show-all').removeClass('hidden');
  $('.js-price-filter').parents('.collapse-nav').trigger('click');
  MicroModal.show('modal-filters', {
    onShow: onShow,
    onClose: onClose,
  });
});

$('#js-open-year-filters').on('click', function () {
  $('.js-filter').addClass('hidden');
  $('.js-filter-short').addClass('hidden');
  $('.js-year-filter').removeClass('hidden');
  $('.js-show-all').removeClass('hidden');

  MicroModal.show('modal-filters', {
    onShow: onShow,
    onClose: onClose,
  });
});

$('#js-show-all').on('click', function () {
  $('.js-filter').removeClass('hidden');
  $('.js-filter-short').addClass('hidden');
});

// Tag F-150

$('.js-tag-f150').on('click', function () {
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:filter:model',
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
    },
    vehicle: {
      nameplate: 'F-150',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

// Tag Checkbox Filters
$('.vlp-results').on('change', '.filter-container input[type=checkbox]', function () {
  if ($(this).prop('checked')) {
    const nameplates = ['make', 'model', 'year'];
    const status = $('.search-results').attr('data-sale-status');
    let filterType = $(this).parents('.filter-container').attr('id');

    if (filterType === 'engine_type') {
      filterType = 'engine';
    } else if (filterType === 'odometer') {
      filterType = 'mileage';
    }

    const config = {
      onclick: {
        onclick: status + ':si:vls:filter:' + filterType,
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:filter',
      },
    };

    if (nameplates.includes(filterType)) {
      const value =
        filterType == 'year'
          ? $(this).siblings('label').text().trim()
          : $(this).siblings('span').text().split('(')[0].trim();
      config.vehicle = {};
      if (filterType == 'year') {
        config.vehicle.modelYear = value;
      } else {
        config.vehicle.nameplate = value;
      }
    }
    TagManager.trackEvent('global-onclick', config);
  }
});

// Tag Sort By Filters

$('.dsp-drop-select').on('change', function () {
  const val = $(this).find(':selected').text().trim();
  const status = $('.search-results').attr('data-sale-status');
  const config = {
    onclick: {
      onclick: status + ':si:vls:sort by: ' + val,
      onclickLinkName: 'dc:' + status + ':si:vls:content:action:sort',
    },
  };
  TagManager.trackEvent('global-onclick', config);
});

// Tag Garage Button

$('#vehicle-results-container').on('change', '.vehicle-card [data-garage-toggle-id]', function () {
  if ($(this).prop('checked')) {
    const model = $(this).data('model');
    const make = $(this).data('make');
    const year = $(this).data('year');
    const status = $(this).data('status');

    const config = {
      onclick: {
        onclick: status + ':si:vls:save',
        onclickLinkName: 'dc:' + status + ':si:vls:content:action:save',
      },
    };

    if (year || model || make) {
      config.vehicle = {};
    }

    if (year) {
      config.vehicle.modelYear = year;
    }

    if (model || make) {
      config.vehicle.nameplate = make + ' ' + model;
    }
    config.page = {};
    config.page.pageName = 'dc:' + status + ':si:vls';
    config.page.pageNameNoVehicle = 'dc:' + status + ':si:vls';
    TagManager.trackEvent('global-onclick', config);
  }
});

function onShow() {
  $('body').css('overflow', 'hidden');
}

function onClose() {
  $('body').css('overflow', 'visible');
}

function runDots($this) {
  $('.main-title').find('.filter-dot').removeClass('hidden').addClass('inline-block');

  $this.parents('.js-filter').find('.filter-dot').removeClass('hidden').addClass('inline-block');

  if ($this.parents('.js-filter').hasClass('js-price-filter')) {
    $('.modal__title.js-price-filter')
      .find('.filter-dot')
      .removeClass('hidden')
      .addClass('inline-block');
  }
  if ($this.parents('.js-filter').hasClass('js-model-filter')) {
    $('.modal__title.js-model-filter')
      .find('.filter-dot')
      .removeClass('hidden')
      .addClass('inline-block');
  }
  if ($this.parents('.js-filter').hasClass('js-year-filter')) {
    $('.modal__title.js-year-filter')
      .find('.filter-dot')
      .removeClass('hidden')
      .addClass('inline-block');
  }
}

function runResets() {
  $('.filter-resets').each(function () {
    $(this).removeClass('hidden').addClass('inline-flex');
  });
}

const inventoryPage = $('.inventory-page');
const isExposed = $('.inventory-page .filters-exposed').length != 0;
const filtersBar = isExposed
  ? document.querySelector('.all-filters__exposed-controls')
  : document.querySelector('.all-filters__controls');

if (inventoryPage.length !== 0 && filtersBar) {
  const sentinal = document.createElement('div');
  filtersBar.parentNode.insertBefore(sentinal, filtersBar);

  sentinal.style.position = 'absolute';
  sentinal.style.top = (filtersBar.offsetTop - 18) + 'px';
  sentinal.style.height = '1px';
  sentinal.style.width = '1px';

  // Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) {
      filtersBar.classList.add('is-sticking');
    } else {
      filtersBar.classList.remove('is-sticking');
    }
  });

  observer.observe(sentinal);
}

$(document).on(InventorySearchEvents.PRE_FETCH, (e) => {
  $('.all-filters__counts').each(function() {
    $(this).addClass('loading');
  });
});

$(document).on(InventorySearchEvents.POST_RENDER, (e, vehicleContainer) => {
  const resultsCounts = $(vehicleContainer).find('.vehicle-results-counts');
  const count = resultsCounts.attr('data-count');
  const total = resultsCounts.attr('data-total');
  $('.all-filters__counts').each(function() {
    $(this).find('.count').text(count);
    $(this).find('.total').text(total);
    $(this).removeClass('loading');
  });
  runResets();
});
